import { createFileRoute } from '@tanstack/react-router'

import { ClubPage } from '@/features/club/ClubPage'

export const Route = createFileRoute('/_app/club')({
  component: ClubPage,
})
